import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { posthogTrackEvent, AuthEvents } from "../assets/posthog";

export default function Login() {
  const { loginWithRedirect, isAuthenticated, isLoading, error } = useAuth0();
  const navigate = useNavigate();

  // todo should catch error and handle it
  useEffect(() => {
    if (error) {
      alert(error);
      posthogTrackEvent({
        event: AuthEvents.LOGIN_FAILURE,
        properties: {
          error: error.message,
          error_description:
            (error as any).error_description || "Unknown error",
        },
      });
    } else {
      if (isAuthenticated) {
        posthogTrackEvent({
          event: AuthEvents.LOGIN_SUCCESS,
          properties: {
            timestamp: new Date().toISOString(),
          },
        });
        navigate("/");
      } else {
        posthogTrackEvent({
          event: AuthEvents.LOGIN,
          properties: {
            method: "auth0_redirect",
          },
        });
        loginWithRedirect();
      }
    }
  }, [isLoading, error]);

  return <div></div>;
}
